import React, { useState, useEffect } from 'react';
import axios from "axios";
import { withRouter } from "react-router-dom";

import { login } from '../../services/auth';

import Logo from '../../assets/logo-agroreceita-branco.svg';
import Email from '../../assets/imagem-email-sucesso.svg';
import InputV2 from '../../components/input/input_v2';

import { theme } from '../../styles/theme';
import { H1, BodyG, BodyGSpan, TaglineM } from '../../styles/stylesTypography';

import * as S from './style';

const PURCHASE_DATALAYER_KEY = '@datalayer_purchase';

const Success = ({ ...props }) => {
    const [methodPayment, setMethodPayment] = useState({
        pix: false,
        boleto: false,
        cartao: false,
    });

    const userInfo = localStorage.getItem('@userinfo')
    const userObject = JSON.parse(userInfo);
    const gtmData = JSON.parse(localStorage.getItem('gtm_data_compra'));

    useEffect(() => {
        if (window.location.search) {
            const params = new URLSearchParams(window.location.search);
            const method = params.get('method') || params.get('type');
        
            switch (method || window.location.search) { 
              case '?boleto':
                setMethodPayment(prev => ({ ...prev, boleto: true, pix: false, cartao_credito: false }));
                break;
              case '?cartao_credito':
                setMethodPayment(prev => ({ ...prev, cartao_credito: true, pix: false, boleto: false }));
                break;
              default:
                setMethodPayment(prev => ({ ...prev, pix: true, boleto: false, cartao_credito: false }));
            }
        }

        try {
            const raw = localStorage.getItem(PURCHASE_DATALAYER_KEY);
            if (raw) {
                const parsed = JSON.parse(raw);

                const valorTransacao = Number(parsed?.valor_transacao);
                const item = String(parsed?.item ?? '').trim();
                const moeda = String(parsed?.moeda ?? 'BRL').trim() || 'BRL';
                const orderId = String(parsed?.order_id ?? '').trim();

                if (Number.isFinite(valorTransacao) && valorTransacao > 0 && item) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: 'compra_finalizada',
                        valor_transacao: valorTransacao,
                        moeda,
                        order_id: orderId,
                        item
                    });
                }
            }
        } catch {
        }

        localStorage.removeItem('@store');
      }, []);

    const redirectHome = () => {
        let password = localStorage.getItem('@useraccesskey');
        let user = JSON.parse(localStorage.getItem('@userinfo'))

        const username = user.username;

        if (password) {
            const psswd = Buffer.from(password, 'base64').toString('utf8');

            if (username && psswd) {
                try {
                    const headers = {
                        'apiKey': process.env.REACT_APP_API_KEY
                    }
                    axios.post(`${process.env.REACT_APP_API_HOST}/login`, { username, password: psswd }, { headers })
                        .then(response => {

                            if (response) {
                                login(response.data.data);
                                localStorage.setItem('@useraccesskey', Buffer.from(psswd, 'utf8').toString('base64'))
                                window.location = "/";
                            }
                        }).catch(error => {
                            window.location = "/";
                        });
                } catch (err) {
                    window.location = "/";
                }
            } else {
                window.location = '/';
            }
        } else {
            const googleProfile = JSON.parse(localStorage.getItem('@agroreceita_google_user_profile'));

            const id = googleProfile.id;

            if (id) {
                try {
                    const headers = {
                        'apiKey': process.env.REACT_APP_API_KEY
                    }
                    axios.post(`${process.env.REACT_APP_API_HOST}/login`, { username, password: id }, { headers })
                        .then(response => {
                            if (response) {
                                login(response.data.data);
                                localStorage.setItem('@useraccesskey', Buffer.from(id, 'utf8').toString('base64'))
                                window.location = "/";
                            }
                        }).catch(error => {
                            window.location = "/";
                        });
                } catch (err) {
                    window.location = "/";
                }
            } else {
                window.location = '/';
            }
        }
    }

    return (
        <S.ContainerSuccess>
            <S.ContainerLeft>
                <img src={Logo} alt="" />

                <S.ContainerTextWithEmail>
                    {methodPayment?.pix ? (
                        <H1 color={theme.colors.white.Branco}>Enviamos seu código PIX!</H1>
                    ) : methodPayment?.boleto ? (
                        <H1 color={theme.colors.white.Branco}>Enviamos seu boleto!</H1>
                    ) : methodPayment?.cartao_credito ? (
                        <H1 color={theme.colors.white.Branco}>Seu pagamento está sendo processado</H1>
                    ) : ""}

                    <S.TextWithEmail>
                        {methodPayment ? (
                            <>
                                <BodyG color={theme.colors.gray.Cinza_9}>
                                    {methodPayment?.pix ? "Seu código PIX foi enviado para o e-mail" : 
                                    methodPayment?.boleto ? "Seu boleto foi enviado para o e-mail" : 
                                    "Em breve você receberá uma confirmação do seu pagamento no e-mail"}  &nbsp;

                                    <BodyGSpan color={theme.colors.white.Branco}>
                                        {userObject.username}
                                    </BodyGSpan>. Após a confirmação do pagamento sua conta será liberada automaticamente.
                                </BodyG>

                                <BodyG>Caso não encontre nosso e-mail, confira sua caixa de spam.</BodyG>
                            </>
                        ) : ("")}
                    </S.TextWithEmail>
                </S.ContainerTextWithEmail>

                <S.ButtonHome onClick={() => window.location.href = '/login'}>
                    <TaglineM color={theme.colors.white.Branco}>Voltar para o sistema</TaglineM>
                </S.ButtonHome>
            </S.ContainerLeft>

            <img src={Email} alt="Imagem envelope de email" />

            <form style={{ display: 'none' }} id='form-cadastro'>
                <InputV2
                    id="nome_usuario"
                    value={gtmData?.nome}
                    label="Nome"
                    marginBottom='0px'
                />

                <InputV2
                    id="email_usuario"
                    value={gtmData?.email}
                    label="E-mail"
                    marginBottom='0px'
                />

                <InputV2
                    id="telefonecelular_usuario"
                    value={gtmData?.telefone}
                    label="Telefone/celular"
                    marginBottom='0px'
                />
            </form>
        </S.ContainerSuccess>
    );
}

export default withRouter(Success);
